module.exports = __webpack_public_path__ + "static/coretto-0505b4b1dcde10bfc9cb263af9455115.png";